/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateReceiptRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'
import {CreateReceiptResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'


export const createReceipt = (request: CreateReceiptRequest, options?: CashRequestOptions) => post<CreateReceiptRequest, CreateReceiptResponse>("/cash-app/business-payments/create-receipt", request, {...options, rejectOnError: true })